import { render, staticRenderFns } from "./OrbitApproveRewardModal.vue?vue&type=template&id=2a7557c2"
import script from "./OrbitApproveRewardModal.vue?vue&type=script&lang=ts"
export * from "./OrbitApproveRewardModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitApproveRewardModal.vue?vue&type=style&index=0&id=2a7557c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports